import React from 'react';
import get from 'lodash/get';
import {connect} from 'react-redux';
import Checkbox from 'components/forms/BasicFormFields/Checkbox'
import {resourcesSelector} from "resources/selectors";

const mapStateToProps = (state) => {
    const { currentPlatform } = state.viewAllPlatforms;
    const challenge = get(state.editBreak, 'break', null);
    const resources = resourcesSelector(state.resources);
    const breakId = challenge[currentPlatform];
    const resource = resources[breakId];
    const steps = get(resource, 'steps', []);

    return {
        options: steps.filter(step => !step.deleted).map(({ id, type }) => ({
            value: id,
            textKey: `step_types.${(type).toLowerCase()}`,
            key: id
        }))
    };
};

export default connect(mapStateToProps, null)(Checkbox);


// WEBPACK FOOTER //
// ./public/pages/ViewAllPlatforms/DeleteSteps/DeleteStepsCheckbox.jsx